import * as RadixSwitch from '@radix-ui/react-switch';
import clsx from 'clsx';
import { useId } from 'react';

export interface SwitchProps {
  readonly checked: boolean;
  readonly onCheckedChange: (checked: boolean) => void;
  readonly label: string;
  readonly disabled?: boolean;
  readonly className?: string;
}

export function Switch({ checked, onCheckedChange, label, disabled, className }: SwitchProps) {
  const id = useId();
  return (
    <span className={clsx('et-switch', className)}>
      <RadixSwitch.Root
        id={id}
        checked={checked}
        onCheckedChange={onCheckedChange}
        disabled={disabled}
        className="et-switch__track"
      >
        <RadixSwitch.Thumb className="et-switch__thumb" />
      </RadixSwitch.Root>
      <label htmlFor={id} className="et-switch__label">{label}</label>
    </span>
  );
}
